import { initialCampaignsState } from 'redux/initialState';
import { status } from 'constants/general';

import campaignsActionTypes from './action-types';

const campaignsReducer = (state = initialCampaignsState, { type, payload }) => {
  switch (type) {
    case campaignsActionTypes.FETCH_CAMPAIGNS_LIST:
      return {
        ...state,
        campaignsList: {
          status: status.FETCHING,
        },
      };

    case campaignsActionTypes.FETCH_CAMPAIGNS_LIST_SUCCESS:
      return {
        ...state,
        campaignsList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case campaignsActionTypes.FETCH_CAMPAIGNS_LIST_FAIL:
      return {
        ...state,
        campaignsList: {
          status: status.FAIL,
        },
      };

    case campaignsActionTypes.FETCH_CAMPAIGN_INFO:
      return {
        ...state,
        campaignInfo: {
          status: status.FETCHING,
        },
      };

    case campaignsActionTypes.FETCH_CAMPAIGN_INFO_SUCCESS:
      return {
        ...state,
        campaignInfo: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case campaignsActionTypes.FETCH_CAMPAIGN_INFO_FAIL:
      return {
        ...state,
        campaignInfo: {
          status: status.FAIL,
        },
      };

    case campaignsActionTypes.FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION:
      return {
        ...state,
        addOrEditCampaign: {
          status: status.FETCHING,
        },
      };

    case campaignsActionTypes.FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION_SUCCESS:
      return {
        ...state,
        addOrEditCampaign: {
          status: status.SUCCESS,
        },
      };

    case campaignsActionTypes.FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION_FAIL:
      return {
        ...state,
        addOrEditCampaign: {
          status: status.FAIL,
        },
      };

    case campaignsActionTypes.SET_CAMPAIGN_DETAILS:
      return {
        ...state,
        campaignDetails: {
          ...payload,
        },
      };

    default:
      return state;
  }
};

export default campaignsReducer;
